 
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateNotification = /* GraphQL */ `subscription OnCreateNotification($username: String!) {
  onCreateNotification(username: $username) {
    createdAt
    createdBy
    isRead
    notificationId
    orgId
    payload
    readAt
    readBy
    username
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateNotificationSubscriptionVariables,
  APITypes.OnCreateNotificationSubscription
>;
export const onValidateQueryRecords = /* GraphQL */ `subscription OnValidateQueryRecords($orgId: String!) {
  onValidateQueryRecords(orgId: $orgId) {
    athenaExecutionId
    createdAt
    createdBy
    executionDuration
    executionId
    executionSource
    executionStatus
    lastModifiedAt
    lastModifiedBy
    orgId
    query
    queryDescription
    queryId
    queryName
    segmentedFanCount
    status
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnValidateQueryRecordsSubscriptionVariables,
  APITypes.OnValidateQueryRecordsSubscription
>;
